/**
 * The ixFileSelect directive can be used to make any element to act like file select button.
 * When this element is clicked or a file is dropped on it the provided object in the ngModel attribute will be updated with this file.
 * Internally this directive writes a hidden input element to the end of the DOM. To make sure the file is set on the right input element you can
 * or better should provide a attr-id to the ix-file-select attribute.
 *
 * !! It would be nice when this directive would use ngForm to invalid the form when a file is selected !!
 * !! It would be nice when this directive would be expanded so the user can select multiple files !!
 *
 * @params {ngModel=}         a object where the selected file is provided as JSON
 * @params {attr=}            put a string to the ix-file-select attribute to set the id on the hidden input element
 *
 * @usage
 * <div ix-file-select="myfileselect" ng-model="previewPanelCtrl.image">
 *      <ix-back-img ng-if="tenderPreviewPanelCtrl.image.url" image="tenderPreviewPanelCtrl.image.url"></ix-back-img>
 * </div>
 */

angular.module('impactx.fileselect').directive('ixFileSelect', FileSelectDirective);

FileSelectDirective.$inject = ['$timeout', 'FileSelect'];

function FileSelectDirective($timeout, FileSelect) {
    return {
        restrict: 'A',
        require: ['ngModel'],
        scope: {
            ngModel: '=',
            accept: '@'
        },
        link: function(scope, element, attrs) {
            var inputElement;
            var dragCounter = 0;

            scope.$on("$destroy", function() {
                inputElement.parent().remove();
            });

            if(attrs.hasOwnProperty("ixFileSelect")) {
                scope.inputId = attrs["ixFileSelect"];
                scope.accept = attrs["accept"];

                angular.element("body").append('<div class="hide-element"><input id="' + scope.inputId + '" type="file" accept="' + scope.accept + '" ix-limit-file-size></div>');
                inputElement = angular.element("#" + scope.inputId);
            }

            function getFile(file) {
                if(file) {
                    scope.ngModel.fileName = file.name;
                    return FileSelect.readAsDataUrl(file, scope)
                        .then(function(result) {
                            return $timeout(function() {
                                scope.ngModel.file = result;
                            });
                        });
                }
            }

            element.on("click", function() {
                if(scope.inputId) {
                    inputElement.click();
                }
            });

            inputElement.on("change", function(event) {
                if(event) {
                    var file = (event.srcElement || event.target).files[0];
                    if(file) {
                        getFile(file).then(function() {
                            inputElement.val("");
                        });
                    }
                }
            });

            element.on('drop', function(e) {
                angular.element(".hover-mask").remove();
                dragCounter = 0;
                e.preventDefault();
                var file = e.originalEvent.dataTransfer.files[0];
                getFile(file);
            });

            element.on('dragover', function(e) {
                e.originalEvent.dataTransfer.dropEffect = "copy";
                e.preventDefault();
            });

            element.on('dragenter', function(e) {
                dragCounter++;
                if(dragCounter === 1) {
                    element.append('<div class="hover-mask"></div>');
                }
                e.originalEvent.dataTransfer.dropEffect = "copy";
                e.preventDefault();
            });

            element.on('dragleave', function(e) {
                dragCounter--;
                if(dragCounter <= 0) {
                    angular.element(".hover-mask").remove();
                }
                e.originalEvent.dataTransfer.dropEffect = "none";
                e.preventDefault();
            });

            element.on('dragend', function(e) {
                angular.element(".hover-mask").remove();
                e.originalEvent.dataTransfer.dropEffect = "none";
                e.preventDefault();
                dragCounter = 0;
            });
        }
    }
}
